import * as C from "./styles.js";

export default function Default() {
    return (
        <C.Container>
            <h3>Selecione uma opção para ver os detalhes</h3>
        </C.Container>
    )
}